import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "@apollo/client";

import { MadFullFragment, MAD_FULL_FRAGMENT } from "../../fragments";
import { MadQueryVariables } from "../../types";

export const GET_MAD_FULL = gql`
  query getMad($id: ID!) {
    mad(id: $id) {
      ...MadFullFragment
    }
  }
  ${MAD_FULL_FRAGMENT}
`;

export type MadData = { mad: MadFullFragment };

export default (options?: QueryHookOptions<MadData, MadQueryVariables>) => {
  return useQuery<MadData, MadQueryVariables>(GET_MAD_FULL, options);
};
